import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../../../context/globalContext';
import { Button, Drawer, List, Typography, Breadcrumb, Space, Divider } from 'antd';
import { MenuOutlined, LeftOutlined, CheckOutlined, HomeOutlined, CloseOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const CCategoriaInicio = ({ onCategoriaSeleccionada, categoriaSeleccionadaId }) => {
  const { categorias } = useContext(GlobalContext);

  const [nivel1, setNivel1] = useState([]);
  const [nivel2, setNivel2] = useState([]);
  const [nivel3, setNivel3] = useState([]);
  const [nivel4, setNivel4] = useState([]);

  const [cat1, setCat1] = useState(null);
  const [cat2, setCat2] = useState(null);
  const [cat3, setCat3] = useState(null);
  const [cat4, setCat4] = useState(null);

  const [visible, setVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);

  useEffect(() => {
    setNivel1(categorias.filter(c => !c.cat_padre_id));
  }, [categorias]);

  // Sincronizar estado interno del drawer con el filtro actual del listado
  useEffect(() => {
    if (!categorias || categorias.length === 0) return;

    if (!categoriaSeleccionadaId) {
      setCat1(null);
      setCat2(null);
      setCat3(null);
      setCat4(null);
      setNivel2([]);
      setNivel3([]);
      setNivel4([]);
      setCategoriaSeleccionada(null);
      return;
    }

    const byId = (id) => categorias.find(c => c.cat_id === id);

    // Construir camino desde la categoría seleccionada hasta la raíz
    const camino = [];
    let actual = byId(categoriaSeleccionadaId);
    while (actual) {
      camino.unshift(actual);
      if (!actual.cat_padre_id) break;
      actual = byId(actual.cat_padre_id);
    }

    const c1 = camino[0] || null;
    const c2 = camino[1] || null;
    const c3 = camino[2] || null;
    const c4 = camino[3] || null;
    const seleccionada = camino[camino.length - 1] || null;

    setCat1(c1);
    setCat2(c2);
    setCat3(c3);
    setCat4(c4);
    setCategoriaSeleccionada(seleccionada);

    // Preparar listados según la navegación del path
    setNivel2(c1 ? getChildren(c1.cat_id) : []);
    setNivel3(c2 ? getChildren(c2.cat_id) : []);
    setNivel4(c3 ? getChildren(c3.cat_id) : []);
  }, [categorias, categoriaSeleccionadaId]);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const handleResize = () => setIsMobile(mediaQuery.matches);
    handleResize();
    mediaQuery.addEventListener('change', handleResize);
    return () => mediaQuery.removeEventListener('change', handleResize);
  }, []);

  const getChildren = (id) => categorias.filter(c => c.cat_padre_id === id);

  const handleSeleccion = (cat) => {
    setCategoriaSeleccionada(cat);
  };

  const aplicarFiltro = (categoriaParam, shouldClose = true) => {
    const categoria = categoriaParam ?? categoriaSeleccionada;

    if (categoria) {
      setCategoriaSeleccionada(categoria);
      onCategoriaSeleccionada?.(categoria.cat_id);
    }

    if (shouldClose) {
      setVisible(false);
    }
  };

  const limpiarFiltros = () => {
    setCat1(null);
    setCat2(null);
    setCat3(null);
    setCat4(null);
    setNivel2([]);
    setNivel3([]);
    setNivel4([]);
    setCategoriaSeleccionada(null);
    onCategoriaSeleccionada?.(null);
    setVisible(false);
  };

  const volverAtras = () => {
    if (cat4) {
      setCat4(null);
      setNivel4(getChildren(cat3.cat_id));
      setCategoriaSeleccionada(cat3);
      return;
    }

    if (cat3) {
      setCat3(null);
      setNivel3(getChildren(cat2.cat_id));
      setNivel4([]);
      setCategoriaSeleccionada(cat2);
      return;
    }

    if (cat2) {
      setCat2(null);
      setNivel2(getChildren(cat1.cat_id));
      setNivel3([]);
      setNivel4([]);
      setCategoriaSeleccionada(cat1);
      return;
    }

    if (cat1) {
      setCat1(null);
      setNivel2([]);
      setNivel3([]);
      setNivel4([]);
      setCategoriaSeleccionada(null);
    }
  };

  const getBreadcrumbItems = () => {
    const items = [{ title: <HomeOutlined />, onClick: limpiarFiltros }];
    if (cat1) items.push({ title: cat1.cat_nombre });
    if (cat2) items.push({ title: cat2.cat_nombre });
    if (cat3) items.push({ title: cat3.cat_nombre });
    if (cat4) items.push({ title: cat4.cat_nombre });
    return items;
  };

  const tieneNavegacionAtras = () => cat1 || cat2 || cat3 || cat4;

  return (
    <>
      <Button
        style={{
          backgroundColor: 'white',
          color: '#01634C',
          borderColor: '#01634C',
          fontWeight: 'bold',
          borderRadius: 6,
          display: 'flex',
          alignItems: 'center',
          minWidth: isMobile ? '40px' : '120px',
          width: isMobile ? '40px' : '120px',
          height: isMobile ? '40px' : '32px',
          padding: isMobile ? 0 : undefined,
          justifyContent: 'center',
          boxSizing: 'border-box'
        }}
        onClick={() => setVisible(true)}
      >
        {isMobile ? <MenuOutlined /> : 'Categorías'}
      </Button>

      <Drawer
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <Text strong style={{ fontSize: '1.1rem' }}>Categorías</Text>
            <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={() => setVisible(false)}
              style={{
                color: '#01634C',
                fontSize: '18px',
                padding: 0,
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            />
          </div>
        }
        placement="left"
        onClose={() => setVisible(false)}
        open={visible}
        bodyStyle={{ padding: 0 }}
        width={isMobile ? '85%' : 400}
        mask={isMobile}
        maskClosable={true}
        closable={false}
      >
        <div style={{ padding: '1rem', height: '100%', display: 'flex', flexDirection: 'column' }}>
          {/* Breadcrumb y botón atrás */}
          {(tieneNavegacionAtras() || categoriaSeleccionada) && (
            <div style={{ marginBottom: '1rem' }}>
              <Space direction="vertical" style={{ width: '100%' }} size="small">
                {tieneNavegacionAtras() && (
                  <Button
                    icon={<LeftOutlined />}
                    onClick={volverAtras}
                    style={{ width: '100%' }}
                  >
                    Volver
                  </Button>
                )}
                <Breadcrumb
                  items={getBreadcrumbItems()}
                  style={{ fontSize: '0.85rem' }}
                />
              </Space>
              <Divider style={{ margin: '0.75rem 0' }} />
            </div>
          )}

          {/* Botón todas las categorías */}
          <div style={{ marginBottom: '1rem' }}>
            <Button
              type="primary"
              block
              onClick={limpiarFiltros}
              style={{ backgroundColor: '#01634C', borderColor: '#01634C', height: '40px' }}
            >
              Todas las categorías
            </Button>
          </div>

          {/* Categoría seleccionada destacada */}
          {categoriaSeleccionada && !cat4 && (
            <div style={{ 
              marginBottom: '1rem', 
              padding: '0.75rem', 
              backgroundColor: '#f6ffed', 
              border: '1px solid #b7eb8f',
              borderRadius: '6px'
            }}>
              <Text strong style={{ color: '#01634C' }}>
                Seleccionado: {categoriaSeleccionada.cat_nombre}
              </Text>
            </div>
          )}

          {/* Contenido scrollable */}
          <div style={{ flex: 1, overflowY: 'auto' }}>
            {!cat1 && (
              <>
                <Title level={5} style={{ marginTop: 0, marginBottom: '0.75rem' }}>Nivel 1</Title>
                <List
                  dataSource={nivel1}
                  bordered={false}
                  renderItem={item => (
                    <List.Item
                      onClick={() => {
                        setCat1(item);
                        const hijos = getChildren(item.cat_id);
                        setNivel2(hijos);
                        setNivel3([]);
                        setNivel4([]);
                        handleSeleccion(item);
                        aplicarFiltro(item, false);
                      }}
                      style={{
                        cursor: 'pointer',
                        padding: '0.75rem',
                        marginBottom: '0.5rem',
                        border: '1px solid #f0f0f0',
                        borderRadius: '6px',
                        transition: 'all 0.2s',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f5f5f5';
                        e.currentTarget.style.borderColor = '#01634C';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'white';
                        e.currentTarget.style.borderColor = '#f0f0f0';
                      }}
                    >
                      {item.cat_nombre}
                    </List.Item>
                  )}
                />
              </>
            )}

            {cat1 && !cat2 && nivel2.length > 0 && (
              <>
                <Title level={5} style={{ marginTop: 0, marginBottom: '0.75rem' }}>Nivel 2</Title>
                <List
                  dataSource={nivel2}
                  bordered={false}
                  renderItem={item => (
                    <List.Item
                      onClick={() => {
                        setCat2(item);
                        const hijos = getChildren(item.cat_id);
                        setNivel3(hijos);
                        setNivel4([]);
                        handleSeleccion(item);
                        aplicarFiltro(item, false);
                      }}
                      style={{
                        cursor: 'pointer',
                        padding: '0.75rem',
                        marginBottom: '0.5rem',
                        border: '1px solid #f0f0f0',
                        borderRadius: '6px',
                        transition: 'all 0.2s',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f5f5f5';
                        e.currentTarget.style.borderColor = '#01634C';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'white';
                        e.currentTarget.style.borderColor = '#f0f0f0';
                      }}
                    >
                      {item.cat_nombre}
                    </List.Item>
                  )}
                />
              </>
            )}

            {cat2 && !cat3 && nivel3.length > 0 && (
              <>
                <Title level={5} style={{ marginTop: 0, marginBottom: '0.75rem' }}>Nivel 3</Title>
                <List
                  dataSource={nivel3}
                  bordered={false}
                  renderItem={item => (
                    <List.Item
                      onClick={() => {
                        setCat3(item);
                        const hijos = getChildren(item.cat_id);
                        setNivel4(hijos);
                        handleSeleccion(item);
                        aplicarFiltro(item, hijos.length === 0);
                      }}
                      style={{
                        cursor: 'pointer',
                        padding: '0.75rem',
                        marginBottom: '0.5rem',
                        border: '1px solid #f0f0f0',
                        borderRadius: '6px',
                        transition: 'all 0.2s',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f5f5f5';
                        e.currentTarget.style.borderColor = '#01634C';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'white';
                        e.currentTarget.style.borderColor = '#f0f0f0';
                      }}
                    >
                      {item.cat_nombre}
                    </List.Item>
                  )}
                />
              </>
            )}

            {cat3 && !cat4 && nivel4.length > 0 && (
              <>
                <Title level={5} style={{ marginTop: 0, marginBottom: '0.75rem' }}>Nivel 4</Title>
                <List
                  dataSource={nivel4}
                  bordered={false}
                  renderItem={item => (
                    <List.Item
                      onClick={() => {
                        setCat4(item);
                        handleSeleccion(item);
                        aplicarFiltro(item);
                      }}
                      style={{
                        cursor: 'pointer',
                        padding: '0.75rem',
                        marginBottom: '0.5rem',
                        border: '1px solid #f0f0f0',
                        borderRadius: '6px',
                        transition: 'all 0.2s',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f5f5f5';
                        e.currentTarget.style.borderColor = '#01634C';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'white';
                        e.currentTarget.style.borderColor = '#f0f0f0';
                      }}
                    >
                      {item.cat_nombre}
                    </List.Item>
                  )}
                />
              </>
            )}
          </div>

          {/* Botón aplicar fijo en la parte inferior */}
          {categoriaSeleccionada && (
            <div style={{ 
              paddingTop: '1rem', 
              borderTop: '1px solid #f0f0f0',
              position: 'sticky',
              bottom: 0,
              backgroundColor: 'white'
            }}>
              <Button
                type="primary"
                block
                size="large"
                icon={<CheckOutlined />}
                onClick={() => aplicarFiltro()}
                style={{ backgroundColor: '#01634C', borderColor: '#01634C', height: '45px' }}
              >
                Aplicar filtro: {categoriaSeleccionada.cat_nombre}
              </Button>
            </div>
          )}
        </div>
      </Drawer>
    </>
  );
};

export default CCategoriaInicio;